module.exports = __webpack_public_path__ + "media/svg/VolumeUpFill-9a93fb75.svg";